import { ArrowDropDown } from '@mui/icons-material'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { map } from 'lodash'
import styles from './CustomTable.module.css'
type Order = 'asc' | 'desc'

interface EnhancedTableProps {
  headTitles: string[]
  onRequestSort?: (property: string) => void
  order?: Order
  orderBy?: string
  centerHeadTitles?: boolean
  sortableColumns?: string[]
}

export const CustomTableHead = (props: EnhancedTableProps) => {
  const { headTitles, order, orderBy, onRequestSort = () => {}, centerHeadTitles = false, sortableColumns } = props
  const isSortable = (column: string) => !sortableColumns || sortableColumns.includes(column)

  return (
    <TableHead>
      <TableRow className={styles.tableRowHead}>
        {map(headTitles, headCell => {
          const canSort = isSortable(headCell)
          return (
            <TableCell
              key={headCell}
              align="left"
              padding="none"
              sortDirection={orderBy === headCell ? order : false}
              className={styles.tableCellHead}>
              {canSort && orderBy !== undefined ? (
                <TableSortLabel
                  active={orderBy === headCell}
                  direction={orderBy === headCell ? order : order === 'asc' ? 'desc' : 'asc'}
                  onClick={() => onRequestSort(headCell)}
                  IconComponent={ArrowDropDown}
                  classes={{ icon: styles.sortIcon }}>
                  <div className={centerHeadTitles ? styles.sortLabelContentCenter : styles.sortLabelContent}>
                    <p className={styles.tableCellHeadText}>{headCell}</p>
                  </div>
                </TableSortLabel>
              ) : (
                <div className={centerHeadTitles ? styles.sortLabelContentCenter : styles.sortLabelContent}>
                  <p className={styles.tableCellHeadText}>{headCell}</p>
                </div>
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}
